
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AdvanceConfig": [
      "EscrowAdvanceConfig",
      "StandardAdvanceConfig"
    ],
    "Attribution": [
      "DelinquentInterestAttribution",
      "DrawInterestAttribution",
      "PartialPayoffInterestAttribution",
      "StandardInterestAttribution"
    ],
    "AuditLogEvent": [
      "LoanAuditLogEvent",
      "TaskAuditLogEvent"
    ],
    "AuditLogEvent2": [
      "LoanAuditLogEvent2",
      "TaskAuditLogEvent2"
    ],
    "AuthorizedContact": [
      "BuilderAuthorizedContact",
      "ThirdPartyAuthorizedContact"
    ],
    "AutopaySettings": [
      "DwollaAutopaySettings",
      "NachaAutopaySettings",
      "RepayAutopaySettings",
      "UsioAutopaySettings"
    ],
    "BankruptcyFiledBy": [
      "AuthorizedContactPayer",
      "BorrowerPayer",
      "EntityPayer"
    ],
    "BorrowerDocumentAccess": [
      "AllBorrowerDocumentAccess",
      "WhiteListedBorrowerDocumentAccess"
    ],
    "Charge": [
      "Advance",
      "Fee"
    ],
    "CompanyLateFeeSettings": [
      "CompanyLateFeeSettingsFixed",
      "CompanyLateFeeSettingsPercent"
    ],
    "CompanyPrincipalLateFeeSettings": [
      "CompanyPrincipalLateFeeSettingsFixed",
      "CompanyPrincipalLateFeeSettingsPercent"
    ],
    "CompanyTerminationFeeSettings": [
      "CompanyTerminationFeeSettingsFixed",
      "CompanyTerminationFeeSettingsPercent"
    ],
    "Document": [
      "DefermentWorkoutPlanDocument",
      "DelinquentInterestAppliedDocument",
      "EmailCopyDocument",
      "EscrowAnalysisDocument",
      "Form1098Document",
      "GeneralDocument",
      "MonthlyStatementDocument",
      "PayoffDocument",
      "PrincipalModificationAppliedDocument",
      "PrincipalModificationCancelledDocument",
      "TransferDocument",
      "UploadDocument",
      "VerificationOfMortgageDocument",
      "WorkoutPlanNoticeDocument"
    ],
    "EscrowDue": [
      "InsuranceEscrowDue",
      "MortgageInsuranceEscrowDue",
      "TaxEscrowDue"
    ],
    "EscrowSetting": [
      "InsuranceEscrowSetting",
      "MortgageInsuranceEscrowSetting",
      "TaxEscrowSetting"
    ],
    "LoanLateFee": [
      "LoanLateFeeFixed",
      "LoanLateFeePercent"
    ],
    "LoanPrincipalLateFee": [
      "LoanPrincipalLateFeeDisabled",
      "LoanPrincipalLateFeeFixed",
      "LoanPrincipalLateFeePercent"
    ],
    "LoanTerminationFee": [
      "LoanTerminationFeeDisabled",
      "LoanTerminationFeeFixed",
      "LoanTerminationFeePercent"
    ],
    "Modification": [
      "FlexModification",
      "LoanRecast",
      "PrincipalModification"
    ],
    "NonPerformanceData": [
      "ForeclosureNonPerformanceData",
      "GeneralNonPerformanceData"
    ],
    "PaidOffRecord": [
      "TrackedPaidOffRecord",
      "UntrackedPaidOffRecord"
    ],
    "Payee": [
      "DirectoryPayee",
      "LegacyEscrowPayeeSnapshot"
    ],
    "Payer": [
      "AuthorizedContactPayer",
      "BorrowerPayer",
      "EntityPayer",
      "ThirdPartyPayer"
    ],
    "PaymentToPaymentDue": [
      "AdvanceBreakdown",
      "BalanceReallocationBreakdown",
      "FeeBreakdown",
      "LiquidationBreakdown",
      "PayoffBreakdown",
      "PrincipalPrepaymentBreakdown",
      "StatementBreakdown",
      "SuspenseBreakdown",
      "ThirdPartyBreakdown"
    ],
    "QrpcContact": [
      "AuthorizedContactPayer",
      "BorrowerPayer",
      "EntityPayer",
      "ThirdPartyPayer"
    ],
    "TaskCollectedData": [
      "Chapter7StepAttorneyReliefCollectedData",
      "Chapter7StepCreditorMeetingCollectedData",
      "Chapter7StepFilingStayCollectedData",
      "Chapter7StepHearingDateCollectedData",
      "Chapter7StepHearingOutcomeCollectedData",
      "Chapter13StepAttorneyReferralCollectedData",
      "Chapter13StepCreditorMeetingCollectedData",
      "Chapter13StepFilingStayCollectedData",
      "Chapter13StepPlanInPlaceCollectedData",
      "Chapter13StepPlanMonitoringCollectedData",
      "DelinquencyStepBorrowerResponsePackageCollectedData",
      "DelinquencyStepFlexModificationEligibilityCollectedData",
      "DelinquencyStepFlexModificationTermsCollectedData",
      "DelinquencyStepMortgageAssistanceRequestCollectedData",
      "DelinquencyStepPastGraceCollectedData",
      "DelinquencyStepSendBreachTermsCollectedData",
      "EmptyCollectedData",
      "ForeclosureStepDemandLettersCollectedData",
      "HomeSaleCollectedData",
      "JudicialStateCollectedData",
      "NonJudicialStateCollectedData",
      "ReferForeclosureAttorneyCollectedData",
      "ReoStepContractStatusCollectedData",
      "ReoStepCounterOfferCollectedData",
      "ReoStepEvictionOfOccupiedPropertyCollectedData",
      "ReoStepOfferEvaluationsCollectedData",
      "ReoStepOrderInspectionCollectedData",
      "ReoStepOrderRepairsCollectedData",
      "ReoStepPropertyListingCollectedData",
      "ReoStepPropertyReductionCollectedData"
    ],
    "TaskContext": [
      "BorrowerRequestContext",
      "DocumentTaskContext",
      "EmptyTaskContext",
      "EscrowAnalysisTaskContext",
      "EscrowDueTaskContext",
      "EventTaskContext",
      "MailBundleTaskContext",
      "MonthlyStatementTaskContext",
      "PaymentTaskContext",
      "PayoffPropertiesTaskContext",
      "PayoffTaskContext",
      "PoolContext",
      "TransferDocumentTaskContext",
      "WorkflowStepTaskContext",
      "WorkoutPlanTaskContext"
    ],
    "WorkflowStepMutationResult": [
      "WorkflowInstance",
      "WorkflowStepMutationError"
    ],
    "WorkoutPlan": [
      "BankruptcyCh13WorkoutPlan",
      "DefermentWorkoutPlan",
      "FlexModificationWorkoutPlan",
      "ForbearanceWorkoutPlan",
      "PaymentDeferralWorkoutPlan",
      "RepaymentWorkoutPlan"
    ]
  }
};
      export default result;
    